module.exports = __webpack_public_path__ + "img/Sales_service_pic02.3091ef2d.jpg";